import { View } from './view';

export class LogFailingOnRenderView extends View {

    init() {
        const amountForm = document.createElement('form');
        amountForm.className = 'hs-form stacked guest-form df-f df-f-log-failing';

        const container = this.getDFContainer();
        container.appendChild(amountForm);

        throw new Error('Form crashed on render - Js Logging Test.');
    }

    addGuestFields(nodes: Node[], index: number) {

        const wrapper = document.createElement('div');
        wrapper.className = 'df-guest-set';
        wrapper.id = 'df-guest-set-' + index;

        nodes.forEach(node => {
            wrapper.appendChild(node);
        });

        this.getHtmlElement('.guest-form').append(wrapper);
    }


}
